module.exports = __webpack_public_path__ + "static/img/paternity-father.62c501c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/non-invasive-prenatal-paternity-test/paternity-father.jpg
// module id = W98t
// module chunks = 0